import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BusinessAdminService} from '../../shared/services/business-admin.service';
import {UniversityService} from '../../shared/services/university.service';
import {StorageService} from '../../shared/services/storage.service';

@Component({
    selector: 'app-b-admins',
    templateUrl: './business-admins.component.html',
    styleUrls: ['./business-admins.component.scss']
})
export class BusinessAdminsComponent implements OnInit {
    showSearch = false;
    admins = [];
    universities = [];
    passwordId: any;
    assignUniversityId: any;
    data: any;
    updatePasswordForm: FormGroup;
    assignUniversityForm: FormGroup;
    inputTypePassword = 'password';
    submitted: any = false;
    submitting: any = false;
    searchForm: FormGroup;
    user: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private router: Router,
                private _coreSidebarService: CoreSidebarService,
                public modalService: NgbModal,
                private fb: FormBuilder,
                private businessAdminService: BusinessAdminService,
                private universityService: UniversityService) {
    }

    ngOnInit(): void {
        this.user = StorageService.getItem('self');
        this.refresh();
    }

    refresh() {
        this.updatePasswordForm = this.fb.group({
            'password': ['']
        });
        this.assignUniversityForm = this.fb.group({
            'university_id': ['']
        });
        this.searchForm = this.fb.group({
            'name': [''],
            'username': [''],
            'email': [''],
            'contact': [''],
        });
        this.getUniversities();
        this.get();
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-admin').toggleOpen();
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.get({page: 1, total: null, perpage: 15, pages: null});
            this.toggleSidebar();
        }
    }

    headCentersPage(data: any) {
        this.router.navigateByUrl('business-head-center/' + data.id);
    }

    updatePasswordModal(content, id) {
        this.passwordId = id;
        this.assignUniversityId = undefined;
        this.updatePasswordForm.patchValue({
            'password': ''
        });
        this.modalService.open(content, {'size': 'sm'});
    }

    getUniversities() {
        this.universities = [];
        this.universityService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.universities = data['data'];
            } else {
                this.universities = [];
            }
        });
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.admins = [];
        this.businessAdminService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.admins = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.admins = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
            'email': (this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
            'contact': (this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''
        };
        this.get(params);
    }

    updatePassword() {
        this.submitted = true;
        if (!this.updatePasswordForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'password': (this.updatePasswordForm.value && this.updatePasswordForm.value.password) ? this.updatePasswordForm.value.password : ''
            };
            this.submitting = true;
            this.businessAdminService.updatePassword(this.passwordId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.passwordId = undefined;
                this.updatePasswordForm.patchValue({
                    'password': '',
                });
                this.modalService.dismissAll('');
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.passwordId = undefined;
            });
        }
    }

    assignUniversity() {
        this.submitted = true;
        if (!this.assignUniversityForm.valid) {
            return;
        }
        if (this.submitted) {
            const params = {
                'university_id': (this.assignUniversityForm.value && this.assignUniversityForm.value.university_id) ? this.assignUniversityForm.value.university_id : ''
            };
            this.submitting = true;
            this.businessAdminService.updateUniversity(this.assignUniversityId, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.assignUniversityId = undefined;
                /*this.assignUniversityForm.patchValue({
                    'password': '',
                });*/
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.assignUniversityId = undefined;
            });
        }
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'username': (this.searchForm && this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : '',
            'email': (this.searchForm && this.searchForm.value && this.searchForm.value.email) ? this.searchForm.value.email : '',
            'contact': (this.searchForm && this.searchForm.value && this.searchForm.value.contact) ? this.searchForm.value.contact : ''
        };
        this.get(params);
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    updateStatus(status, data) {
        this.submitted = true;
        if (this.submitted) {
            const params = {
                'status': status
            };
            this.submitting = true;
            this.businessAdminService.updateStatus(data.id, params).subscribe(data => {
                this.submitting = false;
                this.submitted = false;
                this.passwordId = undefined;
                this.modalService.dismissAll('');
                this.get();
            }, error => {
                this.submitting = false;
                this.submitted = false;
                this.passwordId = undefined;
            });
        }
    }

    assignUniversityModal(content, admin) {
        this.passwordId = undefined;
        this.assignUniversityId = admin.id;
        let universityId = (admin && admin['business_admin_detail'] && admin['business_admin_detail']['university'] && admin['business_admin_detail']['university'].id) ? admin['business_admin_detail']['university'].id : '';
        this.assignUniversityForm.patchValue({
            'university_id': universityId
        });
        this.modalService.open(content, {'size': 'sm'});
    }
}
